import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { OpeningLead } from './components/OpeningLead';
import { PainAgitation } from './components/PainAgitation';
import { EmotionalAmplification } from './components/EmotionalAmplification';
import { DreamTransformation } from './components/DreamTransformation';
import { WhyOthersFail } from './components/WhyOthersFail';
import { UniqueMechanism } from './components/UniqueMechanism';
import { ServicePresentation } from './components/ServicePresentation';
import { StoryCredibility } from './components/StoryCredibility';
import { BenefitsTable } from './components/BenefitsTable';
import { RiskReversal } from './components/RiskReversal';
import { UrgencyScarcity } from './components/UrgencyScarcity';
import { MainCTA } from './components/MainCTA';
import { OneLiners } from './components/OneLiners';
import { FAQSection } from './components/FAQSection';
import { MapSection } from './components/MapSection';
import { BeforeAfterCarousel } from './components/BeforeAfterCarousel';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-brand-bg-dark text-white font-sans selection:bg-brand-gold selection:text-brand-bg-dark" data-id="element-1">
        <Header data-id="element-2" />

        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <ServicePresentation data-id="element-5" />
          <BeforeAfterCarousel data-id="element-6" />
          <OpeningLead data-id="element-7" />
          <PainAgitation data-id="element-8" />
          <EmotionalAmplification data-id="element-9" />
          <DreamTransformation data-id="element-10" />
          <WhyOthersFail data-id="element-11" />
          <UniqueMechanism data-id="element-12" />
          <StoryCredibility data-id="element-13" />
          <BenefitsTable data-id="element-14" />
          <RiskReversal data-id="element-15" />
          <UrgencyScarcity data-id="element-16" />
          <MainCTA data-id="element-17" />
          <OneLiners data-id="element-18" />
          <FAQSection data-id="element-19" />
          <MapSection data-id="element-20" />
        </main>

        <Footer data-id="element-21" />
        <RecentPurchaseToast data-id="element-22" />
      </div>
    </LanguageProvider>;
}